// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_93-0";
export var optionCard = "_93-1";